import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArrowRight, Calendar } from "lucide-react";
import Seo from "../components/Seo";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then(r => setPosts(r.data)); }, []);
  return (
    <div className="pt-24 lg:pt-28">
      <Seo title="Travel Blog" path="/blog" description="Travel tips, visa updates and destination guides from Acchajee Travels experts — honeymoon ideas, Schengen visa guides, Kashmir travel seasons and more." />
      <section className="container-p">
        <span className="section-label">Blog</span>
        <h1 className="h1 mt-3">Travel tips, visa updates & destination guides</h1>
        <p className="muted mt-4 max-w-2xl">Stories, tips and updates from our travel experts — updated weekly.</p>
      </section>
      <section className="container-p mt-12 mb-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map(p => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="card-glass overflow-hidden group hover:-translate-y-1 transition" data-testid={`blog-${p.slug}`}>
            <div className="aspect-[16/10] overflow-hidden"><img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" /></div>
            <div className="p-6">
              <div className="text-xs uppercase tracking-widest text-[#006CE4] font-semibold mb-2">{p.category}</div>
              <h3 className="h3 mb-2 line-clamp-2">{p.title}</h3>
              <p className="muted text-sm line-clamp-2">{p.excerpt}</p>
              <div className="flex items-center justify-between mt-5 text-sm">
                <span className="muted flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {new Date(p.created_at).toLocaleDateString()}</span>
                <span className="text-[#FF7D00] font-semibold flex items-center gap-1">Read <ArrowRight className="w-4 h-4" /></span>
              </div>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
